import jump from "jump.js"

export const scrollTo = (id: string) =>
  jump("#" + id, {
    duration: 400,
    offset: -100,
  })
